import { type AffiliatePartnerData } from "../../../models";
import { Icon } from "../../../../../common/components/icon/Icon";
import { IconType } from "../../../../../common/components/icon/IconType";
import { IconSize } from "../../../../../common/components/icon/IconSize";

import classes from "./AffiliateSavePartnerTile.module.less";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useIsMinPhoneSize } from "~/common/hooks/useMediaQuery";
import { Button } from "~/common/components/Button/Button";

interface Props {
  className?: string;
  affiliate: AffiliatePartnerData;
  onSaveClick: () => void;
  onUndoClick: () => void;
  isSaved: boolean;
}

export const AffiliateSavePartnerTile = ({ affiliate, isSaved, onSaveClick, onUndoClick, className }: Props) => {
  const { t } = useTranslation();
  let btnProps;
  if (!isSaved) {
    btnProps = {
      onClick: onSaveClick,
      children: t("affiliateSalesPartner.banner.button.save"),
      "data-test-id": "banner-partner-save",
    };
  } else {
    btnProps = {
      onClick: onUndoClick,
      children: t("common.undo"),
      "data-test-id": "banner-partner-undo",
    };
  }

  const isMobile = useIsMinPhoneSize();

  return (
    <div className={classNames(classes.customContainer, classes.container, className)}>
      {affiliate?.logo && isMobile && (
        <>
          <img src={affiliate.logo} className={classes.logo} />
          <div className={classes.separator} />
        </>
      )}

      <div className={classes.textSection}>
        <Icon
          className={classNames(classes.icon, isSaved && classes.undo)}
          type={isSaved ? IconType.CheckCircleOutline : IconType.InfoCircleOutline}
          size={IconSize.FONT_24}
        />
        <p className={"m-0"}>
          {t(!isSaved ? "affiliateSalesPartner.banner.text.save" : "affiliateSalesPartner.banner.text.saved")}
        </p>
      </div>

      <Button className={classes.button} {...btnProps} />
    </div>
  );
};
